export default __webpack_public_path__ + "static/race-mobile-244aa0450ee4dc79cc4ed12bf95f0324.mp4";